module.exports = __webpack_public_path__ + "static/media/Entranc.ac47d083.jpg";